import { Box, Text, useDisclosure } from "@chakra-ui/react";
import { useContext } from "react";
import { FormattedMessage, useIntl } from "react-intl";

import { LogoutIcon, RanaAlert, RanaButton } from "@nens/ranalib";
import { RanaModal } from "@nens/ranalib";
import { TenantContext } from "@nens/ranalib";

import { cancelButtonText } from "@/translations";

export function LogoutModal() {
  const intl = useIntl();
  const { isOpen, onOpen, onClose } = useDisclosure();

  const tenantContext = useContext(TenantContext);
  const isSSOUser = !tenantContext.isPublic && tenantContext.identityProvider !== "rana";

  return (
    <>
      <RanaButton
        aria-label="signout"
        title={intl.formatMessage({
          id: "signout.button",
          defaultMessage: "Sign out",
        })}
        rightIcon={<LogoutIcon />}
        onClick={onOpen}
        variant="fourthiary"
      >
        <FormattedMessage id="button.sign_out_of_rana" defaultMessage="Sign out of rana?" />
      </RanaButton>
      <RanaModal
        isOpen={isOpen}
        onClose={onClose}
        topBar={<FormattedMessage id="signout.modal.title" defaultMessage="Signout" />}
        maxW="xl"
        buttons={[
          {
            children: cancelButtonText,
            variant: "tertiary",
            onClick: onClose,
          },
          {
            variant: "danger",
            onClick: !tenantContext.isPublic ? tenantContext.logOut : undefined,
            children: intl.formatMessage({
              id: "signout.modal.button",
              defaultMessage: "Sign out",
            }),
          },
        ]}
      >
        <FormattedMessage
          id="signout.are_you_sure"
          defaultMessage="Are you sure you want to sign out?"
        />
        {isSSOUser && (
          <RanaAlert mt={4} status="warning">
            <Box gap={2}>
              <Text display="block" as="strong">
                <FormattedMessage
                  id="signout.warning_title"
                  defaultMessage="Using a shared or public computer?"
                />
              </Text>
              <FormattedMessage
                id="signout.warning_desc"
                defaultMessage="Just a reminder: Signing out of Rana won't sign you out of your SSO provider. To stay fully secure, please make sure to sign out of your SSO account or close your browser entirely."
              />
            </Box>
          </RanaAlert>
        )}
      </RanaModal>
    </>
  );
}
